import {
  LineupConfig as Config,
  filterPosition,
  getUpdateLineupsPayload,
  LineupModel,
  toSortedBySurname,
  updateLineups,
} from '@collector/desktop-feature-lineups'
import { Events } from '@collector/sportsapi-client'
import {
  ParticipantSubType,
  SubParticipantPosition,
} from '@collector/sportsapi-client-legacy'
import { Event, Participant, SubParticipant } from '@collector/sportsapi-types'
import { sportsApiClient } from '@desktop/globalState/sportsApiClient'

import { LineupConfig } from '../../../configuration'

export type PositionKey = 'firstLineup' | 'player' | 'bench' | 'coach'
export type RugbyLeagueLineupModel = LineupModel<PositionKey>
export type RugbyLeagueLineupConfig = Config<PositionKey>

export const lineupConfig: LineupConfig = {
  config: {
    addPlayer: {
      addAllTargets: ['player', 'coach'],
      addAllConfirmText:
        'Do you want to add all season squad as players and pick coach?',
    },
    positions: {
      firstLineup: {
        sectionLabel: '1st lineup',
        showShirtNr: true,
        showCaptainRadio: true,
        showDeleteAll: true,
        maxCount: 13,
        maxCountReasonText: 'First lineup already has 13 players',
        buttonLabel: '1st',
        buttonClass:
          'hover:bg-neutral-9 hover:border-neutral-9 active:bg-neutral-9/50',
        addFoundPlayer: {
          confirmMissingShirtNr: true,
          disableForSubTypes: [ParticipantSubType.Coach],
        },
      },
      player: {
        sectionLabel: 'Players',
        showShirtNr: true,
        showDeleteAll: true,
        buttonLabel: 'PLA',
        buttonClass: 'hover:bg-neutral-light-6 hover:border-neutral-dark-0',
        addFoundPlayer: {
          confirmMissingShirtNr: true,
          disableForSubTypes: [ParticipantSubType.Coach],
        },
      },
      bench: {
        sectionLabel: 'Bench',
        showShirtNr: true,
        buttonLabel: 'BEN',
        buttonClass: 'hover:bg-neutral-light-6 hover:border-neutral-dark-0',
        addFoundPlayer: {
          confirmMissingShirtNr: true,
          disableForSubTypes: [ParticipantSubType.Coach],
        },
      },
      coach: {
        sectionLabel: 'Coach',
        maxCount: 1,
        maxCountReasonText: 'Coach is already added',
        buttonLabel: 'COA',
        buttonClass: 'hover:bg-neutral-light-6 hover:border-neutral-dark-0',
      },
    },
  },
  createLineupModel(players: SubParticipant[]): RugbyLeagueLineupModel {
    return {
      firstLineup: filterPosition(players, SubParticipantPosition.FirstLineup),
      player: filterPosition(players, SubParticipantPosition.Player),
      bench: filterPosition(players, SubParticipantPosition.Bench),
      coach: filterPosition(players, SubParticipantPosition.Coach),
    }
  },
  toSortedLineupModel(
    lineup: LineupModel<PositionKey>,
  ): RugbyLeagueLineupModel {
    return {
      firstLineup: toSortedBySurname(lineup.firstLineup),
      player: toSortedBySurname(lineup.player),
      bench: [...lineup.bench],
      coach: [...lineup.coach],
    }
  },
  async updateLineups(
    eventId: Event['id'],
    participantId: Participant['id'],
    lineup: LineupModel<PositionKey>,
  ): Promise<void> {
    const squad: Events.SubParticipantsSave.SubParticipantsSavePostSquad[] = [
      ...getUpdateLineupsPayload(
        lineup.firstLineup,
        SubParticipantPosition.FirstLineup,
      ),
      ...getUpdateLineupsPayload(lineup.player, SubParticipantPosition.Player),
      ...getUpdateLineupsPayload(lineup.bench, SubParticipantPosition.Bench),
      ...getUpdateLineupsPayload(lineup.coach, SubParticipantPosition.Coach),
    ]

    await updateLineups(sportsApiClient, eventId, participantId, squad)
  },
}
